import { useAuthStore } from "@/store/auth"

export function useUser() {
  const { user, logoutAndRedirect, isLoading } = useAuthStore();

  const logout = () => {
    console.log("로그아웃 실행");
    const redirectPath = logoutAndRedirect();
    console.log("리다이렉트 경로:", redirectPath);
    
    // 페이지 이동
    window.location.href = redirectPath;
  }

  // 사용자 정보가 없거나 불완전하면 기본값 제공
  const displayUser = {
    id: user?.id?.toString() || "unknown",
    name: user?.name || "Guest",
    email: user?.email || "guest@example.com",
    platformMallId: user?.platformMallId,
    isManager: user?.isManager || false,
    isSuperAdmin: user?.isSuperAdmin || false,
    role: "guest" // auth 스토어의 User 타입에 role이 없으므로 기본값
  };

  return {
    user: displayUser,
    logout,
    isLoading
  }
}